import { useMemo } from 'react';
import { useEffectiveWatermark } from '@/hooks/use-effective-watermark';
import { useLibraryEffectiveWatermark } from '@/hooks/use-library-effective-watermark';
import { resolveWatermarkVisibility } from '@/lib/watermark/resolveWatermarkVisibility';

/** Preview watermark state for a project or a library. Both queries are
 *  cache-first, so hosts and ProjectPreview can call this independently. */
export function useWatermarkVisibility({
  showWatermark,
  projectDocumentId,
  libraryDocumentId,
}: {
  showWatermark: boolean | undefined;
  projectDocumentId?: string | null;
  libraryDocumentId?: string | null;
}) {
  const projectWatermark = useEffectiveWatermark(projectDocumentId);
  const libraryState = useLibraryEffectiveWatermark(projectDocumentId ? null : libraryDocumentId);
  return useMemo(
    () =>
      resolveWatermarkVisibility({
        showWatermark: !!showWatermark,
        campaignWatermark: projectWatermark || libraryState.config,
        cpmActive: libraryState.cpmActive,
      }),
    [showWatermark, projectWatermark, libraryState],
  );
}
